import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-T784WM187Z";
const MAX_QUEUED_CALLS = 100;

let initialized = false;
// send()/event() calls made before initGA() (it is deferred, see lib/idle.js) are replayed in order.
const queue = [];

export const initGA = () => {
  if (initialized || typeof window === "undefined") return;

  ReactGA.initialize(MEASUREMENT_ID);
  initialized = true;

  while (queue.length) {
    const [method, args] = queue.shift();
    ReactGA[method](...args);
  }
};

function call(method, args) {
  if (initialized) ReactGA[method](...args);
  else if (queue.length < MAX_QUEUED_CALLS) queue.push([method, args]);
}

// Same surface the app already uses from react-ga4 (send, event).
const ga = {
  send: (...args) => call("send", args),
  event: (...args) => call("event", args),
};

export default ga;
